import React from 'react';
import Color from '../domain/Color';
import { t, props } from 'tcomb-react';
import HTMLComponent from './HTMLComponent';

@props({
  id: t.Str,
  doAcceptCookies: t.maybe(t.Func),
  title: t.Str,
  children: t.Any,
  themeBgColor: t.maybe(Color),
  themeBgFontColor: t.maybe(Color)
})
export default class DefaultUi extends React.Component {
  render () {
    const titleStyle = {
      backgroundColor: this.props.themeBgColor,
      color: this.props.themeBgFontColor
    };
    return (
      <div id={this.props.id}>
      <div className="cols">
        <div className="large-100">
          <div className="cell default-ui">
            <div className="box dark default-ui-title" style={titleStyle}>
              <h1 className="large-text-center"><HTMLComponent>{this.props.title}</HTMLComponent></h1>
            </div>
            <div className="box light default-ui-content">
              {this.props.children}
            </div>
          </div>
        </div>
      </div>
  </div>);
  }
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/DefaultUi.js
 **/